module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-cyrillic-500-normal.woff2?cad7d3d9cb265e334e58e65cd1ae36e8";